import { FbLink } from 'components/FbUI/FbLink'

function Verified() {
  return (
    <div style={{ maxWidth: '400px', flexShrink: 0 }}>
      <h1 className="text-[18px] mb-2 mt-4">Login</h1>
      <p>
        Your email has been verified! <FbLink to="/login">Click here</FbLink> to
        login.
      </p>
    </div>
  )
}

export default Verified
